import { Stack, styled, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { TopPage } from "@/components/elements/TopPage";
import { InnerBox } from "@/components/elements/InnerBox";
import { CASE_BASIC_INFO_TAB } from "@/features/case/constants/caseBasicInfoTab";
import React, { useState } from "react";
import { blue } from "@/theme/colors";
import { CaseTable } from "@/features/case/components/CaseList/CaseTable";

export const CaseListPage = () => {
  const [actionTab, setActionTab] = useState(CASE_BASIC_INFO_TAB.BASIC_FORM);
  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: number) => {
    if (!newValue) {
      setActionTab(CASE_BASIC_INFO_TAB.BASIC_FORM);
    }
    setActionTab(newValue);
  };
  return (
    <Stack minHeight="100vh">
      <Stack direction="row">
        <TopPage
          title="案件管理"
          enablePageBack={false}
          description="各求人の案件を一覧またはボード形式で管理できます。新しい求人に候補者をあてる場合は、求人から案件を作成ください。"
        />
      </Stack>
      <InnerBox
        padding={3}
        mt={2}
        border="none"
        title={<Typography variant="head20Bold">案件一覧</Typography>}
        rightContent={
          <ToggleButtonGroupStyle color="secondary" value={actionTab} onChange={handleChange} exclusive size="small">
            <ToggleButton value={CASE_BASIC_INFO_TAB.BASIC_FORM}>
              <Typography variant="body14">リストビュー</Typography>
            </ToggleButton>
            <ToggleButton value={CASE_BASIC_INFO_TAB.JOB_INFO}>
              <Typography variant="body14">ボードビュー</Typography>
            </ToggleButton>
          </ToggleButtonGroupStyle>
        }
      >
        <Stack flex={1} gap={3}>
          <CaseTable />
        </Stack>
      </InnerBox>
    </Stack>
  );
};

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)`
  border-radius: 16px;
  height: 32px;

  button {
    border: 2px solid ${blue[80]};
    height: 32px;
    width: 116px;
    color: ${blue[80]};
  }

  button.Mui-selected {
    background-color: ${blue[80]};
    color: white;
  }
`;
